import AppContext from 'App/AppContext';
import Task from 'models/tasks/task';
import { TaskKinds } from 'models/tasks/taskType';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { sortOnString } from 'utils/sorting';

export const useFollowUpTemplates = () => {
  const appContext = useContext(AppContext);
  const [templateItems, setTemplateItems] = useState<Task[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(true);
  const isLoadingRef = useRef(false);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const loadTemplates = useCallback(async () => {
    if (isLoadingRef.current) return;

    try {
      isLoadingRef.current = true;
      setIsLoading(true);
      const allTemplates = await appContext.globalDataCache.templates.getItems();

      if (!isMountedRef.current) return;

      const filtered = allTemplates
        .filter((t: Task) => !t.isCompleted() && t.taskKind === TaskKinds.None)
        .sort((a: Task, b: Task) => sortOnString(a.name, b.name));
      setTemplateItems(filtered);
    } catch (err) {
      if (!isMountedRef.current) return;
      appContext.setError(err);
    } finally {
      isLoadingRef.current = false;
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  }, [appContext]);

  return { templateItems, isLoading, loadTemplates };
};
